export default {
  description: `Küçük bir kasabada mutlu bir aile yaşıyordu. Onlardan o kadar etkilenmiştim ki bir duvar resmiyle yaşamlarını yansıtmak istedim. Bu ailede gördüğüm bütün mutlulukları, umudu ve huzuru çizmeye başladım. Resmi bitirmek üzereyken atölyeme geldiler. Resme bakıp sordular: “Bunu siz mi yaptınız?” Büyük bir heyecanla yanıt verdim: “Hayır, aslında siz yaptınız. Ben yalnızca sizde gördüklerimi resmettim.”<nl> Ben heykellerimde insanları mutlu, üzgün, endişeli yani gerçek halleriyle aktarmaya çalıştım. Düşündüklerinin ve hissettiklerinin yüzlerinden okunabilmesi için çabaladım. Belki de bu yüzden bana “gerçeği mermere işleyen usta” diyorlar.`,
  title: `Bu metinlere göre, her iki sanatçıyla ilgili olarak aşağıdakilerden hangisi söylenebilir?`,
  options: [
    {
      title: `Beğenilmekten mutlu oldukları`,
      isTrue: true
    },
    {
      title: `Düşüncelere önem verdikleri`,
      isTrue: false
    },
    {
      title: `İnsanları olduğu gibi yansıttıkları`,
      isTrue: false
    },
    {
      title: `Var olanı değiştirerek aktardıkları`,
      isTrue: false
    }
  ],
  id: 2
};



// WEBPACK FOOTER //
// ./src/assets/sorular/lgs/2.js